import { commonTranslations } from './common';
import { campaignTranslations } from './campaign';
import { topbarTranslations } from './topbar';
import { bloodTestTranslations } from './beneficiary-activites/bloodTest';
import { abhaTranslations } from './beneficiary-activites/abhaCard';
import { campaignDetailsTranslations } from './campaignDetails';
import { medicineTranslations } from './medicine';
import { campCreateTranslations } from './campCreate';
import { beneficiaryListTranslations } from './beneficiaryList';
import { userListTranslations } from './userList';
import { beneficiaryRegisterTranslations } from './beneficiaryRegister';
import { pendingActionsTranslations } from './pendingActions';
import { escalationActionTranslations } from './escalationCreate';
import { doctorConsultationsTranslations } from './beneficiary-activites/doctorConsultations';
import { pharmacyConsultationsTranslations } from './beneficiary-activites/pharmacyConsultations';
import { stemiConsultationsTranslations } from './beneficiary-activites/stemiConsultations';
import { referSchemeTranslations } from './beneficiary-activites/referScheme';
import { referHospitalTranslations } from './beneficiary-activites/referHospital';
import { medicineInventoryTranslations } from './medicineInventory';
import { documentDownloadHubTranslations } from './documentDownloadHubTranslations';
import { adminDashboardTranslations } from './adminDashboard';
import { calendarViewTranslations } from './calendarView';
import { beneficiaryDashboardTranslations } from './beneficiaryDashboardTranslations';
import { searchFilterBarTranslations } from './searchFilterBar';
import { dateRangePickerTranslations } from './dateRangePicker';
import { medicineEntryTranslations } from './drawers/campaign/medicineEntry';
import { campAcceptRejectTranslations } from './drawers/campaign/campAcceptReject';
import { abhaCardCreateTranslations } from './drawers/activities/abhaCardCreate';
import { bloodTestCreateTranslations } from './drawers/activities/bloodTestCreate';
import { doctorProcedureCreateTranslations } from './drawers/activities/doctorProcedureCreate';
import { namoNetraConsultationCreateTranslations } from './drawers/activities/namoNetraConsultationCreate';
import { cancerConsultationCreateTranslations } from './drawers/activities/cancerConsultationCreate';
import { pharmacyProcedureCreateTranslations } from './drawers/activities/pharmacyProcedureCreate';
import { referHospitalCreateTranslations } from './drawers/activities/referHospitalCreate';
import { schemeReferralCreateTranslations } from './drawers/activities/schemeReferralCreate';
import { stemiProcedureCreateTranslations } from './drawers/activities/stemiProcedureCreate';
import { abhaCardDetailsTranslations } from './drawers/activities/abhaCardDetails';
import { bloodTestDetailsTranslations } from './drawers/activities/bloodTestDetails';
import { doctorConsultationDetailsTranslations } from './drawers/activities/doctorConsultationDetails';
import { pharmacyConsultationDetailsTranslations } from './drawers/activities/pharmacyConsultationDetails';
import  { referralLetterDetailsTranslations} from './drawers/activities/referralLetterDetails';
import { stemiDetailsTranslations } from './drawers/activities/stemiDetails';
import { addMedicineStockTranslations } from './dialogs/addMedicineStock';
import { commonDeleteDialogTranslations } from './dialogs/commonDeleteDialog';
import { markAsVisitedTranslations } from './dialogs/markAsVisited';
import { campaignStatusUpdateTranslations } from './dialogs/campaignStatusUpdate';
import { globalMediaStoreTranslations } from './dialogs/globalMediaStore';
import { addMenuDialogTranslations } from './dialogs/addMenuDialog';
import { addPermissionDialogTranslations } from './dialogs/addPermissionDialog';
import { addRoleDialogTranslations } from './dialogs/addRoleDialog';
import { deleteMenuDialogTranslations } from './dialogs/deleteMenuDialog';
import { deleteRoleDialogTranslations } from './dialogs/deleteRoleDialog';
import { deletePermissionDialogTranslations } from './dialogs/deletePermissionDialog';
import { viewRoleDialogTranslations } from './dialogs/viewRoleDialog';
import { deleteSchemeDetailedDialogTranslations } from './dialogs/deleteSchemeDetailedDialog';
import { schemeDetailsPageTranslations } from './dialogs/schemeDetailsPage';
import { schemeFormTranslations } from './dialogs/schemeForm';
import { schemeListTranslations } from './schemeList';
import { campReportTranslations } from './campReport';
import { activityLogTranslations } from './beneficiary-activites/activityLog';
import { beneficiaryCommentsTranslations } from './beneficiary-activites/beneficiaryComments';
import { beneficiaryDocumentsTranslations } from './beneficiary-activites/beneficiaryDocuments';
import { campsVisitedTranslations } from './beneficiary-activites/campsVisited';
import { followUpActionTranslations } from './beneficiary-activites/followUpAction';
import { followUpFormTranslations } from './beneficiary-activites/followUpForm';
import { followUpListTranslations } from './beneficiary-activites/followUpList';
import { beneficiaryDetailTranslations } from './beneficiary-activites/beneficiaryDetail';
import { roleManagementTranslations } from './roleManagement';
import { menuManagementTranslations } from './menuManagement';
import { permissionManagementTranslations } from './permissionManagement';
import { eyeCampDashboardTranslations } from './eyeCampDashboard';
import { eyeCampConsultationListTranslations } from './eyeCampConsultationList';
import { campServiceTypeDashboardTranslations } from './campServiceTypeDashboard';
import { namoNetraDialogTranslations } from './dialogs/namoNetraDialog';
import { referalDocumentUploadTranslations } from './dialogs/referalDocumentUpload';

export const translations = {
    common: commonTranslations,
    campaign: campaignTranslations,
    topbar: topbarTranslations,
    bloodTest: bloodTestTranslations,
    abha: abhaTranslations,
    campaignDetails: campaignDetailsTranslations,
    medicine: medicineTranslations,
    campCreate: campCreateTranslations,
    beneficiaryList: beneficiaryListTranslations,
    userList: userListTranslations,
    beneficiaryRegister: beneficiaryRegisterTranslations,
    pendingActions: pendingActionsTranslations,
    escalationAction: escalationActionTranslations,
    doctorConsultations: doctorConsultationsTranslations,
    pharmacyConsultations: pharmacyConsultationsTranslations,
    stemiConsultations: stemiConsultationsTranslations,
    referScheme: referSchemeTranslations,
    referHospital: referHospitalTranslations,
    medicineInventory: medicineInventoryTranslations,
    documentHub: documentDownloadHubTranslations,
    adminDashboard: adminDashboardTranslations,
    calendarView: calendarViewTranslations,
    beneficiaryDashboard: beneficiaryDashboardTranslations,
    searchFilterBar: searchFilterBarTranslations,
    dateRangePicker: dateRangePickerTranslations,
    medicineEntry: medicineEntryTranslations,
    campAcceptReject: campAcceptRejectTranslations,
    abhaCardCreate: abhaCardCreateTranslations,
    bloodTestCreate: bloodTestCreateTranslations,
    doctorProcedureCreate: doctorProcedureCreateTranslations,
    namoNetraConsultationCreate: namoNetraConsultationCreateTranslations,
    cancerConsultationCreate: cancerConsultationCreateTranslations,
    pharmacyProcedureCreate: pharmacyProcedureCreateTranslations,
    referHospitalCreate: referHospitalCreateTranslations,
    schemeReferralCreate: schemeReferralCreateTranslations,
    stemiProcedureCreate: stemiProcedureCreateTranslations,
    abhaCardDetails: abhaCardDetailsTranslations,
    bloodTestDetails: bloodTestDetailsTranslations,
    doctorConsultationDetails: doctorConsultationDetailsTranslations,
    pharmacyConsultationDetails: pharmacyConsultationDetailsTranslations,
    referralLetterDetails: referralLetterDetailsTranslations,
    stemiDetails: stemiDetailsTranslations,
    addMedicineStock: addMedicineStockTranslations,
    commonDeleteDialog: commonDeleteDialogTranslations,
    markAsVisited: markAsVisitedTranslations,
    campaignStatusUpdate: campaignStatusUpdateTranslations, 
    globalMediaStore: globalMediaStoreTranslations,
    addMenuDialog: addMenuDialogTranslations,
    addPermissionDialog: addPermissionDialogTranslations,
    addRoleDialog: addRoleDialogTranslations,
    deleteMenuDialog: deleteMenuDialogTranslations,
    deleteRoleDialog: deleteRoleDialogTranslations,
    deletePermissionDialog: deletePermissionDialogTranslations,
    viewRoleDialog: viewRoleDialogTranslations,
    deleteSchemeDetailedDialog: deleteSchemeDetailedDialogTranslations,
    schemeDetailsPage: schemeDetailsPageTranslations,
    schemeForm: schemeFormTranslations,
    schemeList: schemeListTranslations,
    campReport: campReportTranslations,
    activityLog: activityLogTranslations,
    beneficiaryComments: beneficiaryCommentsTranslations,
    beneficiaryDocuments: beneficiaryDocumentsTranslations,
    campsVisited: campsVisitedTranslations,
    followUpAction: followUpActionTranslations,
    followUpForm: followUpFormTranslations,
    followUpList: followUpListTranslations,
    beneficiaryDetail: beneficiaryDetailTranslations,
    roleManagement: roleManagementTranslations,
    menuManagement: menuManagementTranslations,
    permissionManagement: permissionManagementTranslations,
    eyeCampDashboard: eyeCampDashboardTranslations,
    eyeCampConsultationList: eyeCampConsultationListTranslations,
    campServiceTypeDashboard: campServiceTypeDashboardTranslations,
    namoNetraDialog: namoNetraDialogTranslations,
    referalDocumentUpload: referalDocumentUploadTranslations,


};
